import React, { Component } from 'react';
import { Form, Input, Label, Button, Dropdown } from '../../../Form';

import withTranslations from '../../../../utils/translations/withTranslations';

class Pneumones extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: true
    };
  }

  next() {
    this.props.saveItem(this.form.formData());
    this.props.next();
  }

  render() {
    const { translate, data = {}, previous } = this.props;
    const { isValid } = this.state;

    return (
      <div className="Pneumones">
        <Form
          ref={form => (this.form = form)}
          onValidationChange={valid => this.setState({ isValid: valid })}
          className="Pneumones__Form"
        >
          <h1>{translate('fiche.pneumones.title')}</h1>

          <Label text={translate('fiche.pneumones.auscultation')} />
          <Dropdown
            name="auscultation"
            data={[
              { value: '-', label: translate('fiche.normal') },
              { value: 'murmurs', label: translate('fiche.pneumones.murmurs') }
            ]}
            rules={['required']}
            defaultValue={data.auscultation}
          />

          <h2>{translate('fiche.pneumones.thorax_expansion')}</h2>

          <div className="Form__Horizontal">
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.pneumones.inspiration')} />
              <Input
                name="inspiration"
                rules={['required']}
                placeholder="cm"
                defaultValue={data.inspiration}
              />
            </div>
            <div className="Form__Horizontal__Item">
              <Label text={translate('fiche.pneumones.expiration')} />
              <Input
                name="expiration"
                rules={['required']}
                placeholder="cm"
                defaultValue={data.expiration}
              />
            </div>
          </div>

          <Label text={translate('fiche.pneumones.vital_capacity')} />
          <Input
            name="vital_capacity"
            rules={['required']}
            placeholder="l"
            defaultValue={data.vital_capacity}
          />

          <Label text={translate('fiche.pneumones.one_second_value')} />
          <Input
            name="one_second_value"
            rules={['required']}
            placeholder="ml"
            defaultValue={data.one_second_value}
          />

          <Button
            solid
            className="Form__Button"
            disabled={!isValid}
            onClick={() => this.next()}
          >
            {translate('fiche.next')}
          </Button>
          <Button
            transparant
            className="Form__Button"
            onClick={() => previous()}
          >
            {translate('fiche.previous')}
          </Button>
        </Form>
      </div>
    );
  }
}

export default withTranslations(Pneumones);
